import { v4 as uuid } from "uuid";
import { resolveDefaultPhoneCountry } from "../../utils/phoneCountry";
import {
  CalendarIcon,
  GridIcon,
  MCQMultiIcon,
  MCQSingleIcon,
  NumberIcon,
  PhoneIcon,
  ShortTextIcon,
  StatementIcon,
  UploadIcon,
  SliderIcon,
  DropdownIcon,
  CalculatedIcon,
  RepeatedDataIcon,
  SummaryIcon,
  RandomizeIcon,
  EligibilityIcon,
  RepeatedMeasureIcon,
  MedicationIcon,
  GroupIcon,
} from "./Icons";

export const displayTypes = [
  "text",
  "phone",
  "date",
  "slider",
  "calculated_field",
  "radio",
  "checkbox",
  "dropdown",
  "number",
];

export const textTypes = ["text", "phone", "date"];
export const number_types = ["number", "slider", "calculated_field"];
export const choice_types = ["radio", "checkbox", "dropdown"];
export const no_validation_types = [
  "statement",
  "upload_file",
  "grid",
  "repeated_data",
  "summary",
  "randomize",
  "eligibility",
  "repeated_measure",
  "medication",
  "group",
];
export const no_advanced_types = [
  "statement",
  "summary",
  "randomize",
  "eligibility",
  "repeated_measure",
  "medication",
  "group",
];

export const noValueTypes = [
  "statement",
  "summary",
  "eligibility",
  "repeated_measure",
  "medication",
  "group",
];

export const IconMap: any = {
  radio: MCQSingleIcon,
  checkbox: MCQMultiIcon,
  dropdown: DropdownIcon,
  text: ShortTextIcon,
  phone: PhoneIcon,
  number: NumberIcon,
  date: CalendarIcon,
  statement: StatementIcon,
  summary: SummaryIcon,
  slider: SliderIcon,
  upload_file: UploadIcon,
  calculated_field: CalculatedIcon,
  grid: GridIcon,
  repeated_data: RepeatedDataIcon,
  randomize: RandomizeIcon,
  eligibility: EligibilityIcon,
  repeated_measure: RepeatedMeasureIcon,
  medication: MedicationIcon,
  group: GroupIcon,
};

export const QuestionLabelMap: any = {
  radio: "FORM_BUILDER.QUESTION_TYPES.MULTIPLE_CHOICE",
  checkbox: "FORM_BUILDER.QUESTION_TYPES.CHECKBOX",
  text: "FORM_BUILDER.QUESTION_TYPES.TEXT",
  phone: "FORM_BUILDER.QUESTION_TYPES.PHONE",
  date: "FORM_BUILDER.QUESTION_TYPES.DATE",
  number: "FORM_BUILDER.QUESTION_TYPES.NUMBER",
  upload_file: "FORM_BUILDER.QUESTION_TYPES.UPLOAD_FILE",
  grid: "FORM_BUILDER.QUESTION_TYPES.GRID",
  statement: "FORM_BUILDER.QUESTION_TYPES.STATEMENT",
  dropdown: "FORM_BUILDER.QUESTION_TYPES.DROPDOWN",
  slider: "FORM_BUILDER.QUESTION_TYPES.SLIDER",
  calculated_field: "FORM_BUILDER.QUESTION_TYPES.CALCULATED_FIELD",
  repeated_data: "FORM_BUILDER.QUESTION_TYPES.REPEATED_DATA",
  summary: "FORM_BUILDER.QUESTION_TYPES.SUMMARY",
  randomize: "FORM_BUILDER.QUESTION_TYPES.RANDOMIZE",
  eligibility: "FORM_BUILDER.QUESTION_TYPES.EXCLUDE_PARTICIPANT",
  repeated_measure: "FORM_BUILDER.QUESTION_TYPES.REPEATED_MEASURE",
  medication: "FORM_BUILDER.QUESTION_TYPES.MEDICATION",
  group: "FORM_BUILDER.QUESTION_TYPES.GROUP",
};

export const questionTypes = [
  {
    key: "1",
    type: "radio",
    titleKey: "FORM_BUILDER.QUESTION_TYPES.MULTIPLE_CHOICE",
    icon: IconMap["radio"],
    applicableTypes: ["visit", "repeated_data", "survey", "screening"],
  },
  {
    key: "2",
    type: "checkbox",
    titleKey: "FORM_BUILDER.QUESTION_TYPES.CHECKBOX",
    icon: IconMap["checkbox"],
    applicableTypes: ["visit", "repeated_data", "survey", "screening"],
  },
  {
    key: "5",
    type: "text",
    titleKey: "FORM_BUILDER.QUESTION_TYPES.TEXT",
    icon: IconMap["text"],
    applicableTypes: ["visit", "repeated_data", "survey", "screening"],
  },
  {
    key: "24",
    type: "phone",
    titleKey: "FORM_BUILDER.QUESTION_TYPES.PHONE",
    icon: IconMap["phone"],
    applicableTypes: ["screening"],
  },
  {
    key: "6",
    type: "number",
    titleKey: "FORM_BUILDER.QUESTION_TYPES.NUMBER",
    icon: IconMap["number"],
    applicableTypes: ["visit", "repeated_data", "survey", "screening"],
  },
  {
    key: "8",
    type: "date",
    titleKey: "FORM_BUILDER.QUESTION_TYPES.DATE",
    icon: IconMap["date"],
    applicableTypes: ["visit", "repeated_data", "survey", "screening"],
  },
  {
    key: "10",
    type: "upload_file",
    titleKey: "FORM_BUILDER.QUESTION_TYPES.UPLOAD_FILE",
    icon: IconMap["upload_file"],
    applicableTypes: ["visit", "repeated_data", "survey", "screening"],
  },
  {
    key: "11",
    type: "grid",
    titleKey: "FORM_BUILDER.QUESTION_TYPES.GRID",
    icon: IconMap["grid"],
    applicableTypes: ["visit", "repeated_data"],
  },
  {
    key: "12",
    type: "statement",
    titleKey: "FORM_BUILDER.QUESTION_TYPES.STATEMENT",
    icon: IconMap["statement"],
    applicableTypes: ["visit", "repeated_data", "survey", "screening"],
  },
  {
    key: "15",
    type: "slider",
    titleKey: "FORM_BUILDER.QUESTION_TYPES.SLIDER",
    icon: IconMap["slider"],
    applicableTypes: ["visit", "repeated_data", "survey", "screening"],
  },
  {
    key: "16",
    type: "dropdown",
    titleKey: "FORM_BUILDER.QUESTION_TYPES.DROPDOWN",
    icon: IconMap["dropdown"],
    applicableTypes: ["visit", "repeated_data", "survey", "screening"],
  },
  {
    key: "17",
    type: "calculated_field",
    titleKey: "FORM_BUILDER.QUESTION_TYPES.CALCULATED_FIELD",
    icon: IconMap["calculated_field"],
    applicableTypes: ["visit", "repeated_data", "survey", "screening"],
  },
  {
    key: "18",
    type: "repeated_data",
    titleKey: "FORM_BUILDER.QUESTION_TYPES.REPEATED_DATA",
    icon: IconMap["repeated_data"],
    applicableTypes: ["visit", "repeated_data"],
  },
  {
    key: "19",
    type: "summary",
    titleKey: "FORM_BUILDER.QUESTION_TYPES.SUMMARY",
    icon: IconMap["summary"],
    applicableTypes: ["visit", "repeated_data", "screening"],
  },
  {
    key: "20",
    type: "randomize",
    titleKey: "FORM_BUILDER.QUESTION_TYPES.RANDOMIZE",
    icon: IconMap["randomize"],
    applicableTypes: ["visit", "repeated_data"],
  },
  {
    key: "21",
    type: "eligibility",
    titleKey: "FORM_BUILDER.QUESTION_TYPES.EXCLUDE_PARTICIPANT",
    icon: IconMap["eligibility"],
    applicableTypes: ["visit", "repeated_data"],
  },
  {
    key: "22",
    type: "repeated_measure",
    titleKey: "FORM_BUILDER.QUESTION_TYPES.REPEATED_MEASURE",
    icon: IconMap["repeated_measure"],
    applicableTypes: ["visit"],
  },
  {
    key: "23",
    type: "medication",
    titleKey: "FORM_BUILDER.QUESTION_TYPES.MEDICATION",
    icon: IconMap["medication"],
    applicableTypes: ["visit", "repeated_data"],
  },
  {
    key: "25",
    type: "group",
    titleKey: "FORM_BUILDER.QUESTION_TYPES.GROUP",
    icon: IconMap["group"],
    applicableTypes: ["visit", "survey", "screening"],
  },
];

export const getQuestionTypes = (type: string) => {
  return questionTypes.filter((q) => q.applicableTypes.includes(type));
};

export const supportedTypes = questionTypes.map((question) => question.type);

const basicField = {
  label: "",
  varname: "",
  helperText: "",
  validations: [],
};

// TODO
const choiceField = () => {
  return {
    ref: uuid(),
    label: "",
    position: 1,
    value: "",
    isOther: false,
  };
};

const multipleChoiceField = () => ({
  ...basicField,
  excludeExport: false,
  properties: {
    required: false,
    orientation: "vertical",
    remarkText: "",
    bulletStyle: "alphabetical",
  },
  choices: [choiceField()],
});

const dropdownField = () => ({
  ...basicField,
  excludeExport: false,
  properties: {
    required: false,
    remarkText: "",
  },
  choices: [choiceField()],
});

const textField = {
  ...basicField,
  isEncrypted: false,
  excludeExport: false,
  properties: {
    required: false,
    allowMultiline: false,
    remarkText: "",
    format: "",
    placeholder: "",
  },
};

const phoneField = {
  ...basicField,
  isEncrypted: false,
  excludeExport: false,
  properties: {
    required: false,
    remarkText: "",
    defaultCountry: resolveDefaultPhoneCountry(),
  },
};

const numberField = {
  ...basicField,
  isEncrypted: false,
  excludeExport: false,
  properties: {
    required: false,
    allowDecimal: false,
    measurementUnit: "",
    remarkText: "",
    placeholder: "",
  },
};

const dateField = {
  ...basicField,
  isEncrypted: false,
  excludeExport: false,
  properties: {
    required: false,
    format: "DD/MM/YYYY",
    placeholder: "",
  },
};

const sliderField = {
  ...basicField,
  isEncrypted: false,
  excludeExport: false,
  properties: {
    required: false,
    minLabel: "",
    maxLabel: "",
    remarkText: "",
    min: 0,
    max: 100,
    step: 1,
  },
};

const uploadField = {
  ...basicField,
  excludeExport: false,
  properties: {
    required: false,
    remarkText: "",
    max: 2,
  },
};

const calculatedField = {
  ...basicField,
  excludeExport: false,
  calculationTemplate: "",
  properties: {
    required: false,
    remarkText: "",
    isHidden: false,
    responseType: "number",
    executionType: "auto",
    defaults: [],
  },
};

const statementField = {
  ...basicField,
  excludeExport: true,
  properties: { isHidden: false },
};

const randomizeField = {
  ...basicField,
  excludeExport: true,
  properties: {},
};

const repeatedMeasureField = {
  ...basicField,
  excludeExport: true,
  properties: {
    showAll: false,
    phaseId: "",
  },
};

const eligibilityField = {
  ...basicField,
  excludeExport: true,
  properties: {},
};

const gridField = {
  ...basicField,
  excludeExport: false,
  properties: {
    required: false,
    remarkText: "",
    gridConfig: {
      fieldType: "row",
      rows: [{ label: "", type: "text" }],
      columns: [{ label: "" }],
    },
  },
};

const repeatedField = {
  ...basicField,
  excludeExport: false,
  properties: {
    required: false,
    remarkText: "",
    repeatedConfig: {
      columns: [
        {
          label: "",
          type: "text",
        },
      ],
    },
  },
};

const medicationField = {
  ...basicField,
  isEncrypted: false,
  excludeExport: false,
  properties: {
    required: false,
    remarkText: "",
  },
};

export const fieldMap = (type: string) => {
  switch (type) {
    case "radio":
      return multipleChoiceField();
    case "checkbox":
      return multipleChoiceField();
    case "dropdown":
      return dropdownField();
    case "text":
      return textField;
    case "phone":
      return phoneField;
    case "date":
      return dateField;
    case "slider":
      return sliderField;
    case "number":
      return numberField;
    case "upload_file":
      return uploadField;
    case "statement":
      return statementField;
    case "summary":
      return statementField;
    case "randomize":
      return randomizeField;
    case "eligibility":
      return eligibilityField;
    case "grid":
      return gridField;
    case "repeated_data":
      return repeatedField;
    case "calculated_field":
      return calculatedField;
    case "repeated_measure":
      return repeatedMeasureField;
    case "medication":
      return medicationField;
    case "group":
      return statementField;
    default:
      return {};
  }
};
